.c7-news-carousel-single-page {
  display: block;
  overflow: hidden;
  overflow: clip;
  height: var(--c7-news-carousel-single-page-height);
  position: relative;

  --swiper-pagination-color: var(--c7-500);
  --c7-news-carousel-single-page-height: 600px;
  --c7-slide-gap: 4rem;
  --c7-swiper-pagination-gap: 1rem;

  .c7-news-carousel-center {
    height: 100%;
    display: flex;
    min-width: 0;

    .c7-news-carousel-left, .c7-news-carousel-right {
      display: flex;
      align-items: center;

      .c7-carousel-navigation {
        width: 44px;
        height: 44px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        padding: 0;
        color: lightgray;

        & > ion-icon {
          width: 36px;
          height: 36px;
          pointer-events: none;
        }
      }
    }

    .c7-news-carousel-main {
      height: 100%;
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;

      c7-slides {
        height: 100%;

        .swiper-wrapper {
          c7-slide {
            align-items: stretch;
            text-align: left;
            height: 100%;

            article {
              display: flex;
              gap: var(--c7-slide-gap);
              height: 100%;

              .c7-news-teaser-picture {
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
                flex: 1 1 50%;
                height: 100%;
                width: 100%;

                c7-img {
                  height: 100%;
                  width: 100%;
                }
              }

              .c7-news-teaser-content {
                flex: 1 1 50%;
                display: flex;
                flex-direction: column;
                gap: 1rem;
                padding: 2rem 0;

                h3 {
                  --max-lines: 2;
                  margin: 0;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: var(--max-lines);
                }

                p {
                  --max-lines: 5;
                  margin: 0;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: var(--max-lines);
                }

                c7-button {
                  margin-top: auto;
                }
              }
            }
          }
        }
      }

      .swiper-horizontal > .swiper-pagination-bullets {
        left: calc(50% + var(--c7-slide-gap) / 2);
        bottom: 0;
        width: fit-content;
        display: flex;
        gap: var(--c7-swiper-pagination-gap);

        .swiper-pagination-bullet {
          margin: 0;
          width: 15px;
          height: 15px;
        }
      }
    }
  }
}

.c7-news-carousel-single-page.size-md,
.c7-news-carousel-single-page.size-sm,
.c7-news-carousel-single-page.size-xs {
  --c7-news-carousel-single-page-height: fit-content;

  c7-slide {
    article {
      flex-direction: column;
      .c7-news-teaser-content {
        padding: 0 0 2rem;
      }
    }
  }
  .swiper-pagination {
    width: 100%;
    left: 0;
    justify-content: center;
  }
}

:host(.size-md) {
  --c7-slide-gap: 2rem;

  c7-slides {
    .swiper-wrapper {
      c7-slide {
        article {
          .c7-news-teaser-picture {
            c7-img {
              height: 400px;
            }
          }
        }
      }
    }
  }
}

.c7-news-carousel-single-page.size-sm {
  --c7-slide-gap: 1rem;

  c7-slides {
    .swiper-wrapper {
      c7-slide {
        article {
          .c7-news-teaser-picture {
            c7-img {
              height: 300px;
            }
          }
        }
      }
    }
  }
}

.c7-news-carousel-single-page.size-xs {
  --c7-slide-gap: 1rem;

  c7-slides {
    .swiper-wrapper {
      c7-slide {
        article {
          .c7-news-teaser-picture {
            c7-img {
              height: 200px;
            }
          }
        }
      }
    }
  }
}
